import React, { Component } from "react";

import RainbowImage from "../../assets/images/rainbow.svg";
import ArrowImage from "../../assets/images/arrow.svg";

import { Divider, Button, Loading } from "../Controls";
import { Link } from "react-router";

import texts from "../../assets/strings/details.js";

import CharityCard from "../SelectCharity/CharityCard";
import ErrorScreen from "./ErrorScreen";
import LogoImage from "../../assets/images/2018/Logo.png";

import "./styles.less";

const renderPersonalDetails = details => (
  <div>
    {details.firstName[0].value}&nbsp;
    {details.lastName[0].value}
    <br />
    {details.email[0].value}&nbsp;
    {details.phone[0].value}&nbsp;
  </div>
);

class ReviewMobile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accepted: false
    };
  }

  toggleAccepted() {
    this.setState({ accepted: !this.state.accepted });
  }

  render() {
    const { reducer } = this.props;
    return (
      <div className="review mobile">
        <h1>{texts.review.h1}</h1>
        <p className="note label">{texts.review.h3}</p>
        <div className="note">
          <h2>{texts.review.titles.charity}</h2>
          <CharityCard charity={reducer.charity} />
        </div>
        <div className="note">
          <h2>{texts.review.titles.personal}</h2>
          <div>{renderPersonalDetails(reducer.personal)}</div>
        </div>
        <div className="note">
          <h2>{texts.review.titles.target}</h2>
          <div>{renderPersonalDetails(reducer.target)}</div>
        </div>
        <div className="note">
          <h2>{texts.review.titles.message}</h2>
          <blockquote>
            <p
              className="quotation"
              dangerouslySetInnerHTML={{
                __html: texts.message.message
                  .replace("{{firstName}}", reducer.target.firstName[0].value)
                  .replace(
                    "{{message}}",
                    reducer.message ? reducer.message : texts.message.noMessage
                  )
                  .replace("{{charity}}", reducer.charity.name)
              }}
            />
          </blockquote>
          <footer>
            <img className="signature-logo" src={LogoImage} />
          </footer>
        </div>
        <div className="note">
          <label>
            <input
              type="checkbox"
              checked={this.state.accepted}
              onChange={() => this.toggleAccepted()}
            />
            I have read and accept the{" "}
            <a className="link" target="_blank" href="/#/legal">
              terms and conditions
            </a>
          </label>
        </div>
        <div className="note">
          <Button
            primary={true}
            large={true}
            disabled={!this.state.accepted}
            onClick={() => this.props.submitDonation(this.props.reducer)}
          >
            <span>
              {texts.review.proceed.replace(
                "{{firstName}}",
                reducer.target.firstName[0].value
              )}
            </span>
          </Button>
        </div>
        {this.props.reducer.loading && <Loading text={texts.review.loading} />}
        {this.props.reducer.error && (
          <ErrorScreen error={this.props.reducer.error} />
        )}
      </div>
    );
  }
}

export default ReviewMobile;



// WEBPACK FOOTER //
// ./components/Review/ReviewMobile.js